import { render, staticRenderFns } from "./orglicense.vue?vue&type=template&id=579079ee&"
import script from "./orglicense.vue?vue&type=script&lang=js&"
export * from "./orglicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports